import { createSelector } from 'reselect';

export const selectMarketingBanner = state => state.marketingBanner;

export const selectMarketingBannerMobile =
  createSelector(selectMarketingBanner, marketingBanner => marketingBanner.mobileBanner);
export const selectMarketingBannerMobileConfig =
  createSelector(selectMarketingBannerMobile, marketingBannerMobile => marketingBannerMobile.config);
export const selectMarketingBannerMobileIsLoaded =
  createSelector(selectMarketingBannerMobile, marketingBannerMobile => marketingBannerMobile.isLoaded);
export const selectMarketingBannerMobileIsLoading =
  createSelector(selectMarketingBannerMobile, marketingBannerMobile => marketingBannerMobile.isLoading);
export const selectMarketingBannerMobilePlacements =
  createSelector(selectMarketingBannerMobile, marketingBannerMobile => marketingBannerMobile.placements);

export const selectMarketingBannerDesktop =
  createSelector(selectMarketingBanner, marketingBanner => marketingBanner.desktopBanner);
export const selectMarketingBannerDesktopConfig =
  createSelector(selectMarketingBannerDesktop, marketingBannerDesktop => marketingBannerDesktop.config);
export const selectMarketingBannerDesktopIsLoaded =
  createSelector(selectMarketingBannerDesktop, marketingBannerDesktop => marketingBannerDesktop.isLoaded);
export const selectMarketingBannerDesktopIsLoading =
  createSelector(selectMarketingBannerDesktop, marketingBannerDesktop => marketingBannerDesktop.isLoading);
export const selectMarketingBannerDesktopPlacements =
  createSelector(selectMarketingBannerDesktop, marketingBannerDesktop => marketingBannerDesktop.placements);
